import { getProductById, type ProductResponse } from "@/infrastructure/services/productService";
import { getProfile } from "@/infrastructure/services/profileService";
import type { ProductFormValues } from "@/pages/adicionar-produtos/types";
import { mapProductToForm } from "@/utils/product-images";
import { useCallback, useState } from "react";

export function useProductEdit() {
  const [initialValues, setInitialValues] = useState<ProductFormValues | null>(null);
  const [initialProduct, setInitialProduct] = useState<ProductResponse | null>(null);
  const [businessName, setBusinessName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const loadProduct = useCallback(async (id: number) => {
    setIsLoading(true); setError("");
    try { const [product, profile] = await Promise.all([getProductById(id), getProfile().catch(() => null)]); setInitialProduct(product); setInitialValues(mapProductToForm(product)); setBusinessName(profile?.titulo ?? ""); }
    catch (requestError) { const message = requestError instanceof Error ? requestError.message : "Não foi possível carregar o produto."; setError(message); throw requestError; }
    finally { setIsLoading(false); }
  }, []);
  return { businessName, error, initialProduct, initialValues, isLoading, loadProduct };
}
